module.exports = __webpack_public_path__ + "static/media/sam-win.0f7929ef.png";